import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import {
  SENSITIVE_CONTENT_TYPE,
  SENSITIVE_PIC_TYPE,
  SENSITIVE_WORD_TYPE,
  SENSITIVE_WORDS
} from './../../../service/constant'

@Component
export class ConstantMixins extends Vue {
  public get sensitiveType() {
    return this.$store.state[SENSITIVE_WORDS]
  }

  public get sensitivePicType() {
    return this.$store.state[SENSITIVE_PIC_TYPE]
  }

  public get sensitiveWordType() {
    return this.$store.state[SENSITIVE_WORD_TYPE]
  }

  public get sensitiveContentType() {
    return this.$store.state[SENSITIVE_CONTENT_TYPE]
  }

  public get sensitivePicAllType() {
    if (this.sensitivePicType && this.sensitivePicType.length > 0)
      return [{ label: '不限', value: 0 }, ...this.sensitivePicType]
    return [{ label: '不限', value: 0 }]
  }

  public get sensitiveWordAllType() {
    if (this.sensitiveWordType && this.sensitiveWordType.length > 0)
      return [{ label: '不限', value: 0 }, ...this.sensitiveWordType]
    return [{ label: '不限', value: 0 }]
  }

  public get sensitiveContentAllType() {
    if (this.sensitiveContentType && this.sensitiveContentType.length > 0)
      return [{ label: '不限', value: 0 }, ...this.sensitiveContentType]
    return [{ label: '不限', value: 0 }]
  }
}
